<template>
    <v-expansion-panel>
        <v-expansion-panel-header hide-actions>
            <template v-slot:default="{ open }">
                <div class="d-flex align-center">
                    <div class="text-subtitle-1 font-weight-bold">Сведения по ИПУ</div>
                    <v-icon v-if="open">arrow_drop_up</v-icon>
                    <v-icon v-if="!open">arrow_drop_down</v-icon>
                </div>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
            <MetersTable :act_date="act_date" :is-contract="isContract" :items="infoCreate['meters']" />
        </v-expansion-panel-content>
        <v-divider color="gray" />
    </v-expansion-panel>
</template>
<script>
import MetersTable from '@/components/acts/actMetersTable.vue';
import { mapGetters } from 'vuex';
import translate from '@/utils/translate.util';

export default {
    name: 'ActionsInfo',
    components: { MetersTable },
    props: ['infoCreate', 'isContract', 'act_date'],
    data: function() {
        return {
            disconnectType: null
        };
    },
    computed: {
        ...mapGetters('refs', ['getShutdownList']),
        shutdownList() {
            return translate(this.getShutdownList, 'full', this.$i18n.locale);
        }
    }
};
</script>

<style scoped></style>
